import { render, staticRenderFns } from "./plusGoodsTabIndex.vue?vue&type=template&id=361b8b44"
import script from "./plusGoodsTabIndex.vue?vue&type=script&lang=js"
export * from "./plusGoodsTabIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports